import "./Repiping.module.css";
import Header from "@/reusable_sections/Header";
import Repiping from "./sections/Repiping";
import RepipingOverview from "./sections/RepipingOverview";
import RepipingProblems from "./sections/RepipingProblems";
import WarningSigns from "./sections/WarningSigns";
import RepipingProcess from "./sections/RepipingProcess";
import FeaturedServices from "./sections/FeaturedServices";
import ProblemCategories from "./sections/ProblemCategories";
import ServiceArea from "./sections/ServiceArea";
import RepipingFAQ from "./sections/RepipingFAQ";
import EmergencyBanner from "./sections/EmergencyBanner";
import Footer from "@/reusable_sections/Footer";
export default function RepipingPage() {
  return <div>
      <Header />
      <Repiping />
      <RepipingOverview />
      <RepipingProblems />
      <WarningSigns />
      <RepipingProcess />
      <FeaturedServices />
      <ProblemCategories />
      <ServiceArea />
      <RepipingFAQ />
      <EmergencyBanner />
      <Footer />
    </div>;
}